import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Async } from 'react-select';
import {
  Modal,
  Button,
  FormGroup,
  ControlLabel,
  FormControl,
} from 'react-bootstrap';

import { createForm, clearCreateRequestError } from '../actions';

import LoadingDots from './ui/LoadingDots';
import axios from 'axios';
import { createRequestErrors } from '../const/formErrors';

const modalFormDefaultState = {
  INNOfOrganization: {
    label: 'ИНН',
    value: '',
  },
  OGRNOfOrganization: {
    label: 'ОГРН',
    value: '',
  },
  FullNameOrganization: {
    label: 'Название компании',
    value: '',
  },
  OrganizationalAndLegalForm: {
    label: 'Организационно-правовая форма',
    value: '',
  },
  OKVEDPrimary: {
    label: 'ОКВЭД (основной)',
    value: '',
  },
  ContactInformationAddress: {
    label: 'Юридический адрес',
    value: '',
  },
  ContactInformationEmail: {
    label: 'Адрес электронной почты',
    value: '',
  },
};

class RequestCreate extends Component {
  state = {
    typeRequest: '',
    modal: false,
    modalForm: modalFormDefaultState,
  };

  onCreate = () => {
    const { createForm } = this.props;

    createForm(
      Object.keys(this.state.modalForm).reduce((acc, key) => {
        return {
          ...acc,
          [key]: this.state.modalForm[key].value,
        };
      }, {}),
    );
  };

  /**
   * Меняет статус у модалки
   */
  onToggleModal = () => {
    this.setState(prevState => ({
      ...prevState,
      modal: !prevState.modal,
    }));
  };

  /**
   * Меняет конкретное состояние модалки
   * @param key
   * @param value
   */
  onChangeControl = (key, value) => {
    this.setState(prevState => {
      return {
        ...prevState,
        modalForm: {
          ...prevState.modalForm,
          [key]: {
            label: prevState.modalForm[key].label,
            value,
          },
        },
      };
    });
  };

  /**
   * Очищает форму на закрытие ошибки создания формы
   */
  onErrorModalClose = () => {
    this.props.clearCreateRequestError();

    this.onToggleModal();

    this.setState(prevState => ({
      ...prevState,
      modalForm: modalFormDefaultState,
      typeRequest: '',
    }));
  };

  /**
   * Поиск по компании, пусть запрос будет тут, из-за специфичности сервиса
   * @param input
   * @param callback
   */
  getOptions = (input, callback) => {
    if (input) {
      axios
        .get(`/mtk/public/v1/company/suggest/${input}`)
        .then(({ data }) => {
          const options = data.map((item, id) => ({
            label: `${item.value} | ИНН ${item.data.inn}`,
            value: `${item.value} | ИНН ${item.data.inn}`,
            modalForm: {
              INNOfOrganization: {
                label: modalFormDefaultState.INNOfOrganization.label,
                value:
                  item?.data?.inn ??
                  modalFormDefaultState.INNOfOrganization.value,
              },
              OGRNOfOrganization: {
                label: modalFormDefaultState.OGRNOfOrganization.label,
                value:
                  item?.data?.ogrn ??
                  modalFormDefaultState.OGRNOfOrganization.value,
              },
              FullNameOrganization: {
                label: modalFormDefaultState.FullNameOrganization.label,
                value:
                  item?.data?.name?.full_with_opf ??
                  modalFormDefaultState.FullNameOrganization.value,
              },
              OrganizationalAndLegalForm: {
                label: modalFormDefaultState.OrganizationalAndLegalForm.label,
                value:
                  item?.data?.opf?.full ??
                  modalFormDefaultState.OrganizationalAndLegalForm.value,
              },
              OKVEDPrimary: {
                label: modalFormDefaultState.OKVEDPrimary.label,
                value:
                  item?.data?.okved ?? modalFormDefaultState.OKVEDPrimary.value,
              },
              ContactInformationAddress: {
                label: modalFormDefaultState.ContactInformationAddress.label,
                value:
                  item?.data?.address?.value ??
                  modalFormDefaultState.ContactInformationAddress.value,
              },
              ContactInformationEmail: {
                label: modalFormDefaultState.ContactInformationEmail.label,
                value:
                  item?.data?.emails?.[0]?.value ??
                  modalFormDefaultState.ContactInformationEmail.value,
              },
            },
          }));

          callback(null, {
            options,
          });
        })
        .catch(() => {
          alert('Ошибка сервера');
        });
    } else {
      callback(null, {
        options: [],
      });
    }
  };

  /**
   * Фильтрация компаний, выводятся только удовлетворяющие по name/OGRN/INN
   * @param options список организаций из getOptions
   * @param searchQuery
   */
  filterOrganizations = (options, searchQuery) => {
    const filtered = options.filter(option => {
      const isNameEntry = option.value
        .toUpperCase()
        .includes(searchQuery.toUpperCase());
      const isOgrnEntry = option.modalForm?.OGRNOfOrganization?.value?.includes(
        searchQuery,
      );
      const isInnEntry = option.modalForm?.INNOfOrganization?.value?.includes(
        searchQuery,
      );

      return isNameEntry || isOgrnEntry || isInnEntry;
    });

    return filtered;
  };

  render() {
    const {
      loaders,
      error,
      isErrorDisplayed,
      clearCreateRequestError,
    } = this.props;

    const shouldDisplayError = !!isErrorDisplayed && this.state.modal;

    return (
      <LoadingDots show={loaders?.['companies'] || !this.props.modeLoaded}>
        <div className="text-block">
          <div className="from-group">
            <div className="input-group row">
              {/*<div className="col-sm-2 col-xs-12 d-flex" style={{alignItems: 'center'}}>*/}
              {/*  <button*/}
              {/*    type="button"*/}
              {/*    className="btn btn-success btn-sm w-btn"*/}
              {/*    onClick={this.onCreate}*/}
              {/*    disabled={!this.state.typeRequest}*/}
              {/*    style={{*/}
              {/*      marginTop: '25px'*/}
              {/*    }}*/}
              {/*  >*/}
              {/*    Создать заявку*/}
              {/*  </button>*/}
              {/*</div>*/}

              <div
                className="col-sm-2 col-xs-12 d-flex"
                style={{ alignItems: 'center' }}
              >
                <button
                  type="button"
                  className="btn btn-success btn-sm w-btn"
                  onClick={this.onToggleModal}
                >
                  Подать заявку
                </button>
              </div>
            </div>
          </div>
        </div>

        {this.state.modal ? (
          <Modal.Dialog>
            <Modal.Header>
              <Modal.Title>Компания</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              {this.state.typeRequest ? (
                <div
                  style={{
                    display: 'flex',
                    border: '1px solid #ccc',
                    borderRadius: '3px',
                    padding: '10px',
                    color: '#333',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  {this.state.typeRequest}
                  <button
                    onClick={() =>
                      this.setState({
                        typeRequest: '',
                        modalForm: modalFormDefaultState,
                      })
                    }
                    style={{
                      fontSize: '35px',
                      backgroundColor: 'unset',
                      border: 'unset',
                    }}
                  >
                    &times;
                  </button>
                </div>
              ) : (
                <Async
                  cache={false}
                  autosize={true}
                  autoload={true}
                  className={'Select'}
                  name="form-field-lang"
                  placeholder="Поиск компаний"
                  value={this.state.typeRequest}
                  style={{ borderColor: '#ccc' }} // : "#4eb43e"
                  loadOptions={this.getOptions}
                  filterOptions={this.filterOrganizations}
                  onChange={value => {
                    this.setState(prevState => ({
                      ...prevState,
                      typeRequest: value?.value || null,
                      modalForm: value?.modalForm || null,
                    }));
                  }}
                />
              )}

              <form style={{ marginTop: '25px' }}>
                {Object.keys(this.state.modalForm).map(key => {
                  return (
                    <FormGroup controlId={key} key={key}>
                      <ControlLabel>
                        {this.state.modalForm[key].label}
                      </ControlLabel>
                      <FormControl
                        value={this.state.modalForm[key].value}
                        onChange={e =>
                          this.onChangeControl(key, e.target.value)
                        }
                      />
                    </FormGroup>
                  );
                })}
              </form>
            </Modal.Body>

            <Modal.Footer>
              <Button onClick={this.onToggleModal}>Отмена</Button>
              <Button
                onClick={this.onCreate}
                bsStyle="primary"
                disabled={!this.state.typeRequest}
              >
                Ок
              </Button>
            </Modal.Footer>
          </Modal.Dialog>
        ) : null}

        {shouldDisplayError ? (
          <div className="modal-vcentered-container">
            <Modal.Dialog>
              <Modal.Header>
                <Modal.Title>Ошибка!</Modal.Title>
              </Modal.Header>

              <Modal.Body>{createRequestErrors[error]}</Modal.Body>

              <Modal.Footer>
                <Button
                  bsStyle="primary"
                  onClick={() => {
                    this.onErrorModalClose();
                  }}
                >
                  Ок
                </Button>
              </Modal.Footer>
            </Modal.Dialog>
          </div>
        ) : null}
      </LoadingDots>
    );
  }
}

RequestCreate.propTypes = {
  loaders: PropTypes.shape({}).isRequired,
  forms: PropTypes.array.isRequired,
};

const mapDispatchToProps = {
  createForm,
  clearCreateRequestError,
};

const mapStateToProps = state => ({
  loaders: state.forms.loaders,
  forms: state.forms.forms,
  modeLoaded: state.forms.modeLoaded,
  error: state.forms.createRequestError.message,
  isErrorDisplayed: state.forms.createRequestError.isDisplayed,
});

export default connect(mapStateToProps, mapDispatchToProps)(RequestCreate);
